export enum RespondStatusEnum {
  COMPLIANT = 'Compliant',
  ALMOST_COMPLIANT = 'Near Compliant',
  NOT_COMPLIANT = 'Under Compliant',
  EXPIRED = 'Expired',
  PENDING = 'Pending',
  BUYER_ANALYZING = 'Buyer Analyzing',
  RESPONSES_DUE = 'Responses Due',
  SUBMITTED = 'Submitted',
  CONTRACTED = 'Contracted',
  PRICING_EXPIRED = 'Pricing Expired',
  RFP_EXPIRED = 'RFP Expired',
  OPEN = 'Open',
  RECEIVED = 'Received',
  PUBLISHED = 'Published',
  PUBLISHED_INTENT = 'Published Intent',
  RESPONSES_DUE_ORANGE = 'Orange',
  RESPONSES_DUE_GREEN = 'Green',
  RESPONSES_DUE_YELLOW = 'Yellow',
  UPDATING_OFFERS = 'UpdatingOffers',
  UPDATE_RESPONSE = 'Update Response',
}
